import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useApp } from '../../context/AppContext';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const Toast = () => {
  const { notification } = useApp();

  return (
    <AnimatePresence>
      {notification && (
        <motion.div 
          initial={{ opacity: 0, y: 50, x: '-50%' }}
          animate={{ opacity: 1, y: 0, x: '-50%' }}
          exit={{ opacity: 0, y: 50, x: '-50%' }}
          className="fixed bottom-10 left-1/2 z-[200] bg-cobalt text-white px-8 py-4 shadow-2xl flex items-center gap-4 journal-border !border-amber"
        >
          <SafeIcon icon={FiIcons.FiInfo} className="text-amber" />
          <span className="text-xs font-bold uppercase tracking-widest">{notification}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Toast;